import {
  Component, Input, Output, EventEmitter, ChangeDetectorRef, HostListener
} from '@angular/core';
import { formService } from '../../Service/formService';
import { Token } from '../../Models/Token';
import { ePayService } from "../../Service/ePayService";
import { DomSanitizer } from '@angular/platform-browser';
import { concat } from 'rxjs';
import { create, all } from 'mathjs';
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

const math = create(all, {});

@Component({
  selector: 'snap-pay',
  templateUrl: 'snappay.component.html',
  styleUrls: ['snappay.component.css'],
  providers: [],
  exportAs: 'ngModel',
  imports: [KENDO_DROPDOWNS, KENDO_INPUTS, CommonModule, FormsModule]
})
export class SnapPayComponent {
  private token: Token = new Token();
  public validCard: boolean = false;
  public sredkey: boolean = false;
  public loadingiframeUrl: boolean = false;
  public valid: boolean = false;
  public invalid: boolean = true;
  public isCardValid: boolean = false;
  public iframeUrl : any = null;

  getQueryVariable(query: string,variable: string) : string {
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return '';
  }

  //Listed card connect for the cc token
  @HostListener('window:message', ['$event'])
  onMessage(e: any) {
    if (this.ePayService) {
      if (e) {
        if (this.ePayService.Processor().toLowerCase().indexOf(e.origin.toLowerCase()) < 0) {
          return false;
        }
        else {
          if (e.data) {
            try {
              //Gateway Tokens
              this.sredkey = false;
              if (e.data.indexOf("&") >= 0) {
                if (e.data.split("&").length > 0) {
                  this.carddata.message = this.getQueryVariable(e.data,"token");
                  this.carddata.brand = this.getQueryVariable(e.data, "brand");
                  this.carddata.expiry = this.getQueryVariable(e.data, "expiry");;
                  this.carddata.valid = true;                  
                  if (math.isNumeric(this.carddata.expiry)) {
                    this.sredkey = true;
                  }
                  console.info('this.carddata', this.carddata);
                }
                else {
                  var errorinfo = JSON.parse(e.data);
                  var message = 'error: ' + errorinfo.error + '; message: ' + errorinfo.message;                  this.carddata.valid = false;
                  this.carddata.validationError = message
                }
              }
              else {
                var errorinfo = JSON.parse(e.data);
                var message = 'error: ' + errorinfo.error + '; message: ' + errorinfo.message;                this.carddata.valid = false;
                this.carddata.validationError = message
              }
            }
            catch
            {
            }
          }
        }
      }
    }
  }

  //get/set the card data
  @Input() get cvv(): number | null {
    if (this.carddata) {
      if (this.carddata.cvv) {
        return parseInt(this.carddata.cvv);
      }
    }
    return null;
  }
  set cvv(value: number) {
    if (this.carddata) {
      this.carddata.cvv = value.toString();
    }
  }

  //get/set the card data
  @Input() get carddata(): Token {
    return this.token;
  }
  set carddata(value: Token) {
    this.token = value;
  }

  @Output() carddataChange: EventEmitter<Token> = new EventEmitter();

  //Get the iframe
  get iframeURL() {
    if (this.iframeUrl) {
      return this.iframeUrl;
    }
  }

  //Validate the card token
  ngAfterViewChecked() {
    this.valid = false;
    if (this.carddata) {
      if (this.carddata.validationError !== undefined) {
        this.valid = false;
      }
      else {
        if (this.carddata.message !== undefined) {
          if (this.carddata.message && this.expirymonth && this.expiryyear && this.cvv) {
            var currentYear = new Date().getFullYear();
            var currentMonth = new Date().getMonth();
            var year = this.expiryyear.toString();
            if (year.length == 2) {
              year = "20" + year;
            }
            if (!(parseInt(year) === currentYear && this.expirymonth < currentMonth)) {
              if (this.cvv.toString().length >= 3) {
                this.carddata.expiry = year + this.expirymonth.toString();
                this.valid = true;
              }
            }
          }
        }
      }
    }
    if (this.sredkey) {
      this.valid = true;
    }
    this.carddata.valid = this.valid;
    this.invalid = !this.valid;

    this.carddataChange.emit(this.carddata);
    this.cdRef.detectChanges();
  }

  constructor(private cdRef: ChangeDetectorRef, private sanitizer: DomSanitizer,
    private FormService: formService, private ePayService: ePayService) {
  }

  //Get the iframe url
  ngOnInit() {
    if (this.ePayService) {
      this.loadingiframeUrl = true;
      this.ePayService.GenerateRequestId().subscribe((token) => {
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(token);
        
        setTimeout(() => {
          this.loadingiframeUrl = false;
        }, 5000, token);
      });
    }
  }

  get EPayService(): ePayService {
    return this.FormService.EPayService;
  }

  public expirymonth: number | undefined = undefined;
  public expiryyear: number | undefined = undefined;

}
